import allowed from '@/core/constants/allowed-roles.constant'

const routes = [
  {
    name: 'dashboards-v2-management',
    path: '/dashboards-v2/management',
    component: () => import('@/modules/dashboards-v2/containers/superset-management.container.vue'),
    meta: {
      requiresAuth: true,
      layout: 'home',
      module: 'dashboards-v2',
      embedFullViewport: true,
      allowedRoles: [...allowed.dashboards_v2.roles],
      breadcrumb: {
        label: 'core.menu.modules.dashboards-v2-management',
        route: 'dashboards-v2-management',
      },
    },
  },
  {
    name: 'dashboards-v2-view',
    path: '/dashboards-v2/view',
    component: () => import('@/modules/dashboards-v2/containers/superset-dashboard-viewer.container.vue'),
    meta: {
      requiresAuth: true,
      layout: 'home',
      module: 'dashboards-v2',
      embedFullViewport: true,
      allowedRoles: [...allowed.dashboards_v2.viewer],
      breadcrumb: {
        label: 'core.menu.modules.dashboards-v2',
        route: 'dashboards-v2-view',
      },
    },
  },
]

export default routes
